import { Banner } from './../../models/banner.model';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import { daApi, MAP_BANNER, paraApi } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  constructor(
    public api: ApiService
  ) { }

  // Na API antiga o banner era um registro unico; na nova e uma lista. A tela do
  // admin edita um so, entao aqui pegamos o primeiro e o patch faz insere-ou-altera.
  get(): Observable<Banner> {
    return this.api.get('/banner?page=1&count=1').pipe(
      map((res: any) => (res && res.data && res.data[0]) ? daApi(res.data[0], MAP_BANNER) : new Banner())
    );
  }

  getLista(): Observable<Banner[]> {
    return this.api.get('/banner').pipe(
      map((res: any) => ((res && res.data) ? res.data : []).map(b => daApi(b, MAP_BANNER)))
    );
  }

  patch(banner: Banner): Observable<any> {

    if (banner && banner.id) {
      return this.api.patch('/banner', paraApi(banner, MAP_BANNER));
    }

    // sem id ainda: confere se ja existe algum registro antes de criar outro
    return this.get().pipe(
      switchMap((existente: Banner) => {
        if (existente && existente.id) {
          banner.id = existente.id;
          return this.api.patch('/banner', paraApi(banner, MAP_BANNER));
        }
        return this.api.post('/banner', paraApi(banner, MAP_BANNER));
      })
    );
  }

  post(banner: Banner): Observable<any> {
    return this.api.post('/banner', paraApi(banner, MAP_BANNER));
  }

  delete(banner: Banner): Observable<any> {
    return this.api.delete(`/banner/${banner.id}`);
  }

  postFile(file: File, url: string, fileName: string) {
    return this.api.postFile(file, url, fileName);
  }
}
